import { createAsyncThunk } from "@reduxjs/toolkit";
import { DesignationState, Designation } from './designationTypes';
import employeeServiceApiInstance from "../../../config/employeeApiConfig";


// Async Thunks
export const createDesignation = createAsyncThunk(
    'designations/create',
    async (designationData: Partial<Designation>, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.post('/designation', designationData);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create designation');
        }
    }
);

export const updateDesignation = createAsyncThunk(
    'designations/update',
    async ({ id, data }: { id: number; data: Partial<Designation> }, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.put(`/designation/${id}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update designation');
        }
    }
);

export const deleteDesignation = createAsyncThunk(
    'designations/delete',
    async (designationId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/designation/${designationId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete designation');
        }
    }
);

export const fetchDesignationById = createAsyncThunk(
    'designations/fetchById',
    async (designationId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/designation/${designationId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch designation');
        }
    }
);

export const fetchAllDesignations = createAsyncThunk(
    'designations/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/designation');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all designations');
        }
    }
);